import React from 'react';
import './notebook-card.css';

const NotebookCard = ({ title, count, className, onClick, notebook }) => {
  const wrapTitle = (text, maxLength = 15) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    const pushChunks = (word) => {
      while (word.length > maxLength) {
        lines.push(word.slice(0, maxLength));
        word = word.slice(maxLength);
      }
      return word;
    };

    for (let word of words) {
      if (word.length > maxLength) {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = '';
        }
        word = pushChunks(word);
        if (word) currentLine = word;
      } else if ((currentLine + ' ' + word).trim().length <= maxLength) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    if (currentLine) lines.push(currentLine);
    return lines.slice(0, 4);
  };

  const titleLines = wrapTitle(title);

  return (
    <div
      role="button"
      tabIndex={0}
      className={`${className} nbcard-outer cursor-pointer relative`}
      onClick={() => onClick(notebook || { title, count, type: 'notebook' })}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick(notebook || { title, count, type: 'notebook' });
      }}
      style={{ perspective: '1200px', width: '155px', height: '204px' }}
    >
      <div className="nbcard__book">
        {/* Bottom leaf never moves */}
        <div className="nbcard__page nbcard__page--c" />
        <div className="nbcard__page nbcard__page--b" />
        <div className="nbcard__page nbcard__page--a" />

        <div className="nbcard__cover">
          <svg
            width="146"
            height="204"
            viewBox="0 0 146 204"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            {/* Notebook background */}
            <rect width="146" height="204" fill="var(--q3-accent-light)" />

            {/* Title */}
            <text
              x="12"
              y="30"
              fontFamily="Inter"
              fontSize="16"
              fontWeight="700"
              fill="var(--q3-neutral-default)"
              style={{ letterSpacing: '-0.16px' }}
            >
              {titleLines.map((line, index) => (
                <tspan key={index} x="12" dy={index === 0 ? '0' : '1.2em'}>
                  {line}
                </tspan>
              ))}
            </text>

            {/* Count */}
            <text
              x="12"
              y="170"
              fontFamily="Inter"
              fontSize="14"
              fontWeight="500"
              fill="var(--q3-neutral-default)"
              style={{ letterSpacing: '-0.14px' }}
            >
              {count}
            </text>

            <text
              x="12"
              y="190"
              fontFamily="Inter"
              fontSize="12"
              fontWeight="400"
              fill="var(--q3-neutral-default)"
              style={{ letterSpacing: '-0.12px' }}
            >
              Bookmarked Qs
            </text>
          </svg>
        </div>

        <div className="nbcard__spine" />
      </div>
    </div>
  );
};

export default NotebookCard;
